class ExtratoFilter {
    constructor($filter, $scope) {
        this.filter = {}
        this.$filter = $filter

        this.mesesReferencia = this.buildMeses()

        $scope.$watch(() => this.filter, () => this.updateFilter(), true)
    }

    $onInit() {
        this.filter.referencia = this.mesesReferencia[1]

        this.updateFilter()
    }

    buildMeses() {
        const today = new Date()

        let month = today.getMonth() + 1
        const dates = []

        for (let i = 1; i < 24; i++) {
            dates.push(new Date(today.getFullYear(), month, 1))
            month -= 1
        }

        return dates
    }

    submit(form) {
        if (form.$valid) {
            this.updateFilter()
        }
    }

    async updateFilter() {
        let filter = angular.copy(this.filter)

        for (let key in filter) if (filter.hasOwnProperty(key) && filter[key] === "") {
            delete filter[key]
        }

        filter.referencia = this.$filter('date')(filter.referencia, 'yyyy-MM-dd')

        this.onChange({$newFilter: filter})
    }
}

angular.module('eficienciaFiscalModule')
    .component('extratoFilter', {
        controller: ['$filter', '$scope', ExtratoFilter],
        bindings: {
            onChange: '&'
        },
        template: `
        <form class="fade-animation" name="form" ng-submit="$ctrl.submit(form)">
            <div class="row">
                <div class="form-group col-sm-4 col-lg-2">
                    <label>
                        Número
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.numero = undefined"
                           ng-if="$ctrl.filter.numero"></i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.numero" ng-model-options="{ debounce: 500 }">
                </div>
                <div class="form-group col-sm-4 col-lg-2">
                    <label>
                        Mês de referência
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.referencia = undefined"
                           ng-if="$ctrl.filter.referencia"></i>
                    </label>
                    <select class="form-control" ng-model="$ctrl.filter.referencia" 
                            ng-options="mes as (mes | date:'MMM/yyyy') for mes in $ctrl.mesesReferencia">
                        <option value="null">...</option>
                    </select>
                </div>
                <div class="form-group col-sm-4 col-lg-2">
                    <label for="" class="hidden-xs">&nbsp;</label>
                    <button type="submit" class="btn btn-primary btn-block"><i class=" fa fa-refresh"></i> Atualizar</button>
                </div>
            </div>
        </form>
        `
    })
